"use client";

export function SocialProof() {
  return (
    <section className="py-10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center gap-8 text-center md:flex-row md:gap-16">
          <p className="text-sm font-medium tracking-wider text-gray-500 uppercase dark:text-gray-400">
            Données 100% souveraines et sécurisées
          </p>
          <div className="flex items-center gap-8 opacity-70 grayscale transition-all hover:opacity-100 hover:grayscale-0">
            {/* Using text placeholders for now as I don't have the SVGs */}
            <div className="flex items-center gap-2 text-xl font-bold text-gray-700 dark:text-gray-300">
              <span className="text-blue-700">OVH</span>cloud
            </div>
            <div className="flex items-center gap-2 text-xl font-bold text-gray-700 dark:text-gray-300">
              Mistral <span className="text-orange-500">AI</span>
            </div>
            <div className="flex items-center gap-2 text-xl font-bold text-gray-700 dark:text-gray-300">
              🇫🇷 RGPD
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
